import type { LocationQueryValue } from 'vue-router'

export const arrayAsString = (
  path:
    | string
    | string[]
    | LocationQueryValue
    | LocationQueryValue[]
    | undefined,
) => (typeof path === 'string' ? path : path?.join('/'))

export const uppercaseFirstLetter = (s: string) =>
  String(s[0]).toUpperCase() + String(s).slice(1)
